<template>
	<div class="pages" :style="{ height: height + 'px' }">
		<navTop></navTop>
		<div class="box">
			<img src="../../assets/paysuccess.png" />
			<p v-if="num == 1">Payment successful</p>
			<p v-if="num == 2">Order cancelled successfully</p>
			<p v-if="num == 3">Submitted</p>
			<p v-if="num == 4">Evaluation success</p>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'cancelSuccess',
	components: {
		navTop
	},
	data() {
		return {
			height: '',
			num: ''
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.height = window.innerHeight;
			this.num = this.$route.query.num;
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		img {
			width: 200px;
			height: 200px;
			display: block;
			margin-top: 258px;
		}
		p {
			font-size: 24px;
			color: #00faff;
			line-height: 1em;
			margin-top: 48px;
		}
	}
}
</style>
